
namespace RioERP.Masters {

    @Serenity.Decorators.registerClass()
    export class DtdcApiDetailsGrid extends Serenity.EntityGrid<DtdcApiDetailsRow, any> {
        protected getColumnsKey() { return DtdcApiDetailsColumns.columnsKey; }
        protected getDialogType() { return DtdcApiDetailsDialog; }
        protected getIdProperty() { return DtdcApiDetailsRow.idProperty; }
        protected getInsertPermission() { return DtdcApiDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return DtdcApiDetailsRow.localTextPrefix; }
        protected getService() { return DtdcApiDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}